import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelpContentDataSource } from './help-content-data-source';
import { JsonHelpContentDataSource } from './json-help-content-data-source';
import { HelpPage } from '../../models/help/help-page.model';
import { FaqPage } from '../../models/help/faq.model';
import { Certification } from '../../models/help/certification.model';
import { SalesChannelsPage } from '../../models/help/sales-channel.model';

interface CmsInformationalPageDto {
  slug: string;
  title: string;
  breadcrumb: string | null;
  body: string | null;
}

@Injectable()
export class ApiHelpContentDataSource extends HelpContentDataSource {
  private get cmsBaseUrl(): string {
    return environment.endpointBasePaths.cmsApiUrl;
  }

  constructor(private readonly http: HttpClient, private readonly jsonSource: JsonHelpContentDataSource) {
    super();
  }

  getPage(slug: string): Observable<HelpPage> {
    return this.http
      .get<CmsInformationalPageDto>(`${this.cmsBaseUrl}public/catalog/informational-pages/${slug}`)
      .pipe(map((dto) => this.mapToHelpPage(dto)));
  }

  getFaq(): Observable<FaqPage> {
    return this.jsonSource.getFaq();
  }

  getSalesChannels(): Observable<SalesChannelsPage> {
    return this.jsonSource.getSalesChannels();
  }

  getCertifications(): Observable<Certification[]> {
    return this.jsonSource.getCertifications();
  }

  getCertificationBySlug(slug: string): Observable<Certification | HelpPage> {
    return this.jsonSource.getCertificationBySlug(slug);
  }

  private mapToHelpPage(dto: CmsInformationalPageDto): HelpPage {
    const body = dto.body?.replace(/&nbsp;/g, ' ') ?? null;
    return {
      id: dto.slug,
      slug: dto.slug,
      title: dto.title,
      breadcrumb: dto.breadcrumb ?? '',
      sections: body ? [{ type: 'innerHtml', innerHtml: body }] : [],
    };
  }
}
